import {Form} from 'antd';
import React, {FC} from 'react';

import {DateInput} from 'components/@common/inputs/date-input';
import {CustomSelect} from 'components/form/inputs/custom-select';
import {DATE_DMY} from 'shared/constants/date-format';

import {EFFECT_INFLUENCE_LOOKUP_URL, YES_NO_LOOKUP_URL} from '../../model/constants';

interface IMainInfoTabProps {
    isReadOnly?: boolean;
}

export const MainInfoTab: FC<IMainInfoTabProps> = ({
    isReadOnly = false,
}: IMainInfoTabProps) => (
    <div className="form-flex">
        <div className="form-flex-row">
            <Form.Item
                name="reportingDate"
                label="Дата, по состоянию на которую представляются сведения"
                rules={[{required: true, message: 'Обязательное поле'}]}
            >
                <DateInput disabled={isReadOnly} format={DATE_DMY} />
            </Form.Item>
            <Form.Item
                name="registryMspId"
                label="Признак наличия налогоплательщика в реестре МСП"
                rules={[{required: true, message: 'Обязательное поле'}]}
            >
                <CustomSelect
                    settings={{
                        showSearch: true,
                        url: YES_NO_LOOKUP_URL,
                        valuePath: 'id',
                        labelPath: 'description',
                        isDisabled: isReadOnly,
                }}
                />
            </Form.Item>
            <Form.Item
                name="backboneEnterpriseId"
                label="Признак отнесения к системообразующим предприятиям"
                rules={[{required: true, message: 'Обязательное поле'}]}
            >
                <CustomSelect
                    settings={{
                        showSearch: true,
                        url: YES_NO_LOOKUP_URL,
                        valuePath: 'id',
                        labelPath: 'description',
                        isDisabled: isReadOnly,
                    }}
                />
            </Form.Item>
        </div>
        <Form.Item
            name="effectInfluenceId"
            label="Повлияли ли макроэкономические факторы (санкции) на вашу компанию и как?"
            rules={[{required: true, message: 'Обязательное поле'}]}
        >
            <CustomSelect
                settings={{
                    showSearch: true,
                    url: EFFECT_INFLUENCE_LOOKUP_URL,
                    valuePath: 'id',
                    labelPath: 'description',
                    isDisabled: isReadOnly,
                }}
            />
        </Form.Item>
    </div>
);
